import { css } from "@emotion/react";
import { useFormContext } from "react-hook-form";
import { Button, Font, Cluster } from "@moneyforward/mfx_biz_react_components";
import { color } from "@/styles/theme";
import { EmailFormField } from "@/components/molecules";
import { CancelButton } from "@/components/atoms";

type FormValues = {
  email: string;
};

type Props = {
  onSubmit: ({ email }: FormValues) => void;
};

export const ChangeToAdminSendMailForm = ({ onSubmit }: Props) => {
  const { handleSubmit, formState } = useFormContext();
  return (
    <div css={container}>
      <div css={box}>
        <form onSubmit={handleSubmit(onSubmit)} css={form}>
          <div css={inputWrapper}>
            <EmailFormField name="email" />
          </div>
          <div css={buttonWrapper}>
            <CancelButton />
            <Button
              type="submit"
              css={buttonMargin}
              disabled={formState.isSubmitting}
            >
              送信
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
  justifyContent: "center",
});

const box = css({
  width: "640px",
  minHeight: "197px",
  padding: "40px 32px",
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const form = css({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

const inputWrapper = css({
  flex: 1,
});

const buttonWrapper = css({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "8px",
});
const buttonMargin = css({
  marginLeft: "16px",
});
